<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="用户昵称">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" placeholder="请输入用户昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="手机号">
                <a-input v-model="queryParam.mobile" @pressEnter="handleQuery" placeholder="请输入手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderNo" @pressEnter="handleQuery" placeholder="请输入订单编号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单标题">
                <a-input v-model="queryParam.title" @pressEnter="handleQuery" placeholder="请输入账单标题" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="资金类型">
                <a-select v-model="queryParam.fundType" placeholder="请选择资金类型" allow-clear>
                  <a-select-option value="1">充值余额</a-select-option>
                  <a-select-option value="50">用户积分</a-select-option>
                  <a-select-option value="30">可提现余额</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="dateRange"
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="handleDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
<!--      <div class="table-operations">-->
<!--        <a-button type="primary" @click="handleExport">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
<!--      </div>-->
      <!-- 数据表格 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 2000 }"
        @change="handleTableChange"
      >
        <span slot="changeMoney" slot-scope="text, record">
          <span :style="{ color: record.sign === '+' ? '#52c41a' : '#ff4d4f' }">
            {{ record.sign }}{{ text }}
          </span>
        </span>
        <span slot="billType" slot-scope="text">
          <a-tag v-if="text === '1'" color="green">活动增加</a-tag>
          <a-tag v-else-if="text === '2'" color="red">消费减少</a-tag>
          <a-tag v-else color="default">{{ text }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text">
          {{ moment(text).format('YYYY-MM-DD HH:mm:ss') }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :current="queryParam.pageNum"
        :pageSize="queryParam.pageSize"
        :pageSizeOptions="pageSizeOptions"
        :total="total"
        :showTotal="getTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAccountBill, exportAccountBill } from "@/api/user/bill";
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: "AccountBill",
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        userId: undefined,
        nickName: undefined,
        mobile: undefined,
        orderNo: undefined,
        title: undefined,
        billType: undefined,
        type: undefined,
        fundType: undefined,
        sortField: 'createTime',
        sortOrder: 'desc'
      },
      // 日期范围
      dateRange: [],
      // 账单流水表格数据
      billList: [],
      // 表格列
      columns: [

        {
          title: '用户昵称',
          dataIndex: 'nickName',
          width: 150,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          width: 130,
          align: 'center'
        },
        {
          title: '操作前金额',
          dataIndex: 'beforeMoney',
          width: 120,
          align: 'center'
        },
        {
          title: '变化金额',
          dataIndex: 'changeMoney',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'changeMoney' }
        },
        {
          title: '操作后金额',
          dataIndex: 'afterMoney',
          width: 120,
          align: 'center'
        },
        {
          title: '账单类型',
          dataIndex: 'billType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'billType' }
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '账单标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    moment,
    getTotal(total) {
      return '共' + total + '条'
    },
    /** 查询用户账户流水列表 */
    getList() {
      this.loading = true;
      const params = { ...this.queryParam };
      if (this.dateRange && this.dateRange.length === 2) {
        params.createBeginTime = this.dateRange[0].format('YYYY-MM-DD HH:mm:ss');
        params.createEndTime = this.dateRange[1].format('YYYY-MM-DD HH:mm:ss');
      }
      pageAccountBill(params).then(response => {
        this.list = response.data.records;
        this.total = response.data.total;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        userId: undefined,
        nickName: undefined,
        mobile: undefined,
        orderNo: undefined,
        title: undefined,
        billType: undefined,
        type: undefined,
        fundType: undefined,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.getList();
    },
    /** 日期变化 */
    handleDateChange(dates) {
      this.dateRange = dates;
    },
    /** 表格变化 */
    handleTableChange(pagination, filters, sorter) {
      this.queryParam.pageNum = pagination.current;
      this.queryParam.pageSize = pagination.pageSize;
      if (sorter.field) {
        this.queryParam.sortField = sorter.field;
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc';
      }
      this.getList();
    },
    /** 分页变化 */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize;
      this.getList();
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current;
      this.queryParam.pageSize = pageSize;
      this.getList();
    },
    /** 导出按钮操作 */
    handleExport() {
      const params = { ...this.queryParam };
      if (this.dateRange && this.dateRange.length === 2) {
        params.createBeginTime = this.dateRange[0].format('YYYY-MM-DD HH:mm:ss');
        params.createEndTime = this.dateRange[1].format('YYYY-MM-DD HH:mm:ss');
      }
      this.$confirm({
        title: '确认导出',
        content: '是否确认导出所有用户账户流水数据项?',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.loading = true;
          exportAccountBill(params).then(response => {
            this.download(response, '用户账户流水数据.xls');
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    /** 下载文件 */
    download(response, fileName) {
      const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }
};
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
.table-operations {
  margin-bottom: 16px;
}
.table-page-search-submitButtons {
  display: block;
  margin-bottom: 24px;
  white-space: nowrap;
}
</style>
